import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyC4sm9yDcDbg95fRI246_cjbCM-fdPzE3g",
  authDomain: "illuminantmedicalai.firebaseapp.com",
  projectId: "illuminantmedicalai",
  storageBucket: "illuminantmedicalai.appspot.com",
  messagingSenderId: "317724567823",
  appId: "1:317724567823:web:your-app-id",
  databaseURL: "https://illuminantmedicalai-default-rtdb.firebaseio.com"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app); 